type ModelValuesByDataIndexProps = {
  [dataIndex: string]: (string | undefined | number)[]; // CSV Model Defaults Values;
};

export const modelValuesByDataIndex = (): ModelValuesByDataIndexProps => ({
  iccid: [
    '89553202000000159564',
    '89553202000000157854',
    '89553202000000151243',
  ],
  newIccid: [
    '89553202000000157854',
    '89553202000000151243',
    '89553202000000159564',
  ],
  msisdn: ['5503404446239', '5503404444567', '5503404442390'],
  newMsisdn: ['5503404444567', '5503404446239', '5503404442390'],
  imsi: ['724320200047912', '724320200048956', '724320200043452'],
  imei: ['610837348244440', '027744873463469', '307533703589937'],
  vendor: ['TIM', 'VIVO', 'ALGAR'],
  newVendor: ['TIM', 'VIVO', 'ALGAR'],
  blockType: [1, 2, 3],
  blockStartDate: ['20211120', '20220223', '20230112'],
  blockEndDate: [undefined, '20230112', undefined],
  unlockDate: ['20220116', '20220130', '20220201'],
  newNickname: ['Nick 1', 'Nick 2', 'Nick 3'],
  requestId: ['331', '456', '987'],
  groupingId: ['331', '456', '987'],
  customerId: ['421421', '409568', '803492'],
  value: ['20', '12', '2'],
  devEui: ['357c82512a00fefb', '72d70b8cc24a6090', '055aaa8c3a523ce4'],
  appEui: ['5f7e090d8b6f8975', '4de0442322bb5c2d', 'b33076b61ad12948'],
  tags: ['tag_1', 'tag_2;tag_3;tag_4', 'tag_5;tag_6'],
  description: ['description 1', 'description 2', 'description 3'],
  newCustomerVirtualAccountId: ['0', '12345', '56789'],
  apn: ['apn1', 'apn2', 'apn3'],
  base64Payload: ['YWdlbmRhbWVudG8=', 'ZG93bmxpbms=', 'bG9yYXdhbg=='],
  payloadHex: ['YWdlbmRhbWVudG8=', 'ZG93bmxpbms=', 'bG9yYXdhbg=='],
  port: [1, 1, 1],
  fPort: [1, 1, 1],
  confirmed: ['false', 'true', 'false'],
  flushDownlinkQueue: ['false', 'true', 'false'],
  unit: ['B', 'KB', 'MB'],
  connections: ['123;456;789', '456', '789;123'],
  linkMode: ['APPEND', 'DELETE', 'REPLACE'],
});
